<!-- src/components/common/NouvelleVersion.vue -->
<!--
  Bandeau « nouvelle version disponible » (02/10/2026), admin et client.

  Le serveur sert index.html en `no-cache` : un CHARGEMENT de page prend toujours la dernière
  version. Mais un onglet resté ouvert continue de faire tourner l'ancien code tant qu'on ne le
  recharge pas — c'est ainsi que le bandeau d'alarme non vue (B11) est resté invisible juste
  après sa mise en ligne. On compare donc, de temps en temps, le script principal annoncé par
  index.html à celui qui tourne. Différent : on PROPOSE de recharger, on ne recharge jamais
  d'office — ce serait couper quelqu'un au milieu d'une saisie.
-->
<template>
  <div v-if="nouvelle" role="status"
       class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-md flex items-center justify-between gap-3 px-4 py-3 rounded-lg shadow-lg bg-primary-600 text-white text-sm">
    <span>{{ $t('nouvelleVersion.texte') }}</span>
    <button type="button" @click="recharger"
            class="flex-shrink-0 px-3 py-1.5 rounded-md bg-white text-primary-700 font-semibold hover:bg-primary-50">
      {{ $t('nouvelleVersion.recharger') }}
    </button>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';

const MOTIF = /\/js\/app\.[0-9a-f]+\.js/;
const INTERVALLE_MS = 5 * 60 * 1000;

export default defineComponent({
  name: 'NouvelleVersion',
  setup() {
    const nouvelle = ref(false);
    // Le script qui tourne. Absent (serveur de développement, sans empreinte) : rien à surveiller.
    const courant = Array.from(document.scripts).map(s => (s.getAttribute('src') || '').match(MOTIF))
      .find(Boolean);
    const enCours = courant && courant[0];
    let minuteur = null;

    const verifier = async () => {
      if (!enCours || nouvelle.value || document.hidden) return;
      try {
        const r = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const m = (await r.text()).match(MOTIF);
        if (m && m[0] !== enCours) nouvelle.value = true;
      } catch { /* hors connexion : on réessaiera */ }
    };
    const auRetour = () => { if (!document.hidden) verifier(); };
    const recharger = () => window.location.reload();

    onMounted(() => {
      if (!enCours) return;
      minuteur = setInterval(verifier, INTERVALLE_MS);
      document.addEventListener('visibilitychange', auRetour);
    });
    onBeforeUnmount(() => {
      clearInterval(minuteur);
      document.removeEventListener('visibilitychange', auRetour);
    });
    return { nouvelle, recharger };
  }
});
</script>
